<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <h1 class="title">开发者注册</h1>
        <p class="subtitle">创建您的开发者账号以开始使用</p>
      </div>

      <el-form 
        :model="registerFrom" 
        :rules="rules" 
        ref="loginFromRef" 
        class="register-form"
        label-position="top">
        
        <el-form-item prop="email">
          <el-input 
            prefix-icon="el-icon-message"
            placeholder="请输入邮箱" 
            v-model="registerFrom.email" 
            @input="changeInput">
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            placeholder="至少6位密码，区分大小写"
            v-model="registerFrom.password"
            type="password"
            show-password
            @input="changeInput">
          </el-input>
        </el-form-item>

        <el-form-item prop="repassword">
          <el-input
            prefix-icon="el-icon-circle-check"
            placeholder="请再次确认密码"
            v-model="registerFrom.repassword"
            type="password"
            show-password
            @input="changeInput">
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <div class="captcha-container">
            <el-input
              prefix-icon="el-icon-key"
              placeholder="验证码"
              v-model="registerFrom.code"
              class="captcha-input"
              @input="changeInput">
            </el-input>
            <div class="captcha-img" v-html="code" @click="getCode" title="点击更换验证码"></div>
          </div>
        </el-form-item>

        <div class="support-info">
          <p><i class="el-icon-warning-outline"></i> 若收不到邮件请联系管理 QQ: 58346871</p>
        </div>

        <div class="action-links">
          <span>已有账号？</span>
          <router-link to="/login">立即登录</router-link>
        </div>

        <el-form-item>
          <el-button type="primary" class="reg-btn" @click="register">注 册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const checkEmail = (rule, value, cb) => {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) return cb();
      cb(new Error('请输入有效的邮箱地址'));
    };
    const validatePass2 = (rule, value, cb) => {
      if (value === '') {
        cb(new Error('请再次输入密码'));
      } else if (value !== this.registerFrom.password) {
        cb(new Error('两次输入密码不一致!'));
      } else {
        cb();
      }
    };
    return {
      registerFrom: {
        email: "",
        password: "",
        repassword: "",
        code: "",
        type: "developer",
        sign:""
      },
      code:"",
      rules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: ["blur", "change"] },
          { min: 6, max: 32, message: "长度在 6 到 32 个字符", trigger: ["blur", "change"]},
          {validator:checkEmail,trigger:'blur'}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 6, max: 32, message: "长度在 6 到 32 个字符", trigger: ["blur", "change"]},
        ],
        repassword: [
          { required: true, message: "请确认密码", trigger: ["blur", "change"] },
          { min: 6, max: 32, message: "长度在 6 到 32 个字符", trigger: ["blur", "change"]},
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
      },
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    // reset() {
    //   /**
    //    * 需要表单重置
    //    * 并且需要移除校验结果
    //    */
    //   // this.registerFrom.email = "";
    //   // this.registerFrom.password = "";
    //   this.$refs.loginFromRef.resetFields();
    // },
    register() {
      this.$refs.loginFromRef.validate(async (value) => {
        if (!value) return this.$message.error("请检查输入信息");
        console.log("this.$route.query.ref:",this.$route.query.ref);
        this.registerFrom.ref = this.$route.query.ref
        const res = await this.$http.post("register", this.registerFrom);
        if (res.data.meta.status !== 200) {
          this.getCode();
          return this.$message.error(res.data.meta.msg);
        } else {
          window.sessionStorage.setItem("register", this.registerFrom.email);
          return this.$router.push("/result");
        }
      });
    },
    async getCode() {
      //this.imgSrc = this.imgSrc = this.imgSrc+Date.parse(new Date())
      let result = await this.$http.get('getcode?' + Date.parse(new Date()))
      this.code = result.data.img
      this.registerFrom.sign = result.data.sign
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
  }
}

.captcha-container {
  display: flex;
  gap: 12px;
  .captcha-input { flex: 1; }
  .captcha-img {
    flex: 0 0 110px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    /deep/ div, /deep/ svg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.action-links {
  text-align: right;
  margin: -10px 0 20px 0;
  a {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
}

.submit-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.support-info {
  margin: -10px 0 15px 0;
  p {
    font-size: 12px;
    color: #f56c6c;
    line-height: 1.4;
  }
}

.action-links {
  text-align: right;
  margin-bottom: 20px;
  font-size: 14px;
  span { color: #606266; }
  a {
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
    &:hover { text-decoration: underline; }
  }
}

.reg-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  letter-spacing: 4px;
  border-radius: 8px;
}

.login_container {
  background-color: #2b4b6b;
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items:center;/*垂直居中*/
  a {
    text-decoration: none;
    color: #409eff;
    font-size: 15px;
  }
  .title {
    text-align: center;
    h2 {
      margin: 20;
    }
  }

  .el-form {
    // width: 400px;
    height: 470px;
    background-color: #fff;
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    border-radius: 5px;
    border-top: 1px solid;
    padding: 0 20px;
    .form-content {
      margin-top: 25px;
      .info {
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
      }
    }
    .el-form-item {
      margin-top: 30px;
      .left,
      .code {
        float: left;
        width: 45%;
        height: 40px;
        img {
          // border: 1px solid #eee;
          width: 100%;
          height: 100%;
          // margin-left: 55px;
        }
        div {
          width: 100%;
          height: 100%;
          text-align: center;
          vertical-align: -9px;
          
        }
      }
      .el-button {
        float: right;
        margin-left: 20px;
        width: 100%;
        margin-top: -15px;
      }
    }
  }
}

/* 移动端全屏策略 */
@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15%;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}
</style>